import {
  TablePage,
} from 'src/views/abi/billing-record'
import pathMap from 'src/paths/pathMap'

class AbiBillingRecordRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_BILLING_RECORD_PATH,
        component: TablePage
      }
    ]
  }
}

export default AbiBillingRecordRoute
